export enum IssueStatusEnum {
  DRAFT = 'issue-draft',
  OPEN = 'issue-open',
  IN_PROGRESS = 'issue-in-progress',
  TO_BE_APPROVED = 'issue-to-be-approved',
  CLOSED = 'issue-closed',
  DISCARDED = 'issue-discarded',
}

export type IssueStatusType =
  | IssueStatusEnum.DRAFT
  | IssueStatusEnum.OPEN
  | IssueStatusEnum.IN_PROGRESS
  | IssueStatusEnum.TO_BE_APPROVED
  | IssueStatusEnum.CLOSED
  | IssueStatusEnum.DISCARDED;

export const IssueStatusNotActionable = [
  IssueStatusEnum.CLOSED,
  IssueStatusEnum.DISCARDED,
];

export const IssueStatusActionable = [
  IssueStatusEnum.DRAFT,
  IssueStatusEnum.OPEN,
  IssueStatusEnum.IN_PROGRESS,
  IssueStatusEnum.TO_BE_APPROVED,
];
